import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useTraduction } from "../../Contexte/TraductionContext";

function Client() {

    const { contentAccueil } = useTraduction()

    const slider1Ref = useRef(null);
    const slider2Ref = useRef(null);
    const [slider1Width, setSlider1Width] = useState(0);
    const [slider2Width, setSlider2Width] = useState(0);

    const itemscard = contentAccueil.Client || [];

    useEffect(() => {
        const calculateSliderWidth = (sliderRef) => {
            if (sliderRef.current) {
                const cards = sliderRef.current.querySelectorAll(".card");
                const cardLength = cards.length;
                const currentWidth = ((cardLength * 272) + ((cardLength - 1) * 32)) /2;
                return currentWidth;
            }
            return 0;
        };

        const slider1Width = calculateSliderWidth(slider1Ref);
        setSlider1Width(slider1Width);

        const slider2Width = calculateSliderWidth(slider2Ref);
        setSlider2Width(slider2Width);
    }, [itemscard]);

    const filtereditemscard1 = itemscard.filter(item => item.Slider === 1);
    const filtereditemscard2 = itemscard.filter(item => item.Slider === 2);

    
    return (
        <section id="Client" className="mt-124">
            <h3 className="container">{contentAccueil.GrosTitreClient}</h3>
            
            <div id="Slider1" className="cards mt-64 left-translate" style={{ width: `3632px` }} ref={slider1Ref}>
                {filtereditemscard1.map((item, index) => (
                    <Link to={item.Site}>
                    <div key={index} className="card">
                        <img loading="lazy" className="LogoClient" src={"../../../Assets/visuels/images/home/customer/" + item.Logo + ".webp"} alt={"Logo " + item.Client} />
                        <div className="Secteur">
                            <img loading="lazy" src={item.Icon} alt={item.Icon} />
                            <p>{item.Secteur}</p>
                        </div>
                    </div>
                    </Link>
                ))}

                {filtereditemscard1.map((item, index) => (
                    <Link to={item.Site}>
                    <div key={index} className="card">
                        <img loading="lazy" className="LogoClient" src={"../../../Assets/visuels/images/home/customer/" + item.Logo + ".webp"} alt={"Logo " + item.Client} />
                        <div className="Secteur">
                            <img loading="lazy" src={item.Icon} alt="" />
                            <p>{item.Secteur}</p>
                        </div>
                    </div>
                    </Link>
                ))}
            </div>

            <div id="Slider2" className="cards mt-32 transform right-translate" style={{ width: `3632px` }} ref={slider2Ref}>
                {filtereditemscard2.map((item, index) => (
                    <Link to={item.Site}>
                    <div key={index} className="card">
                        <img loading="lazy" className="LogoClient" src={"../../../Assets/visuels/images/home/customer/" + item.Logo + ".webp"} alt={"Logo " + item.Client} />
                        <div className="Secteur">
                            <img loading="lazy" src={item.Icon} alt="" />
                            <p>{item.Secteur}</p>
                        </div>
                    </div>
                    </Link>
                ))}

                {filtereditemscard2.map((item, index) => (
                    <Link to={item.Site}>
                    <div key={index} className="card">
                        <img loading="lazy" className="LogoClient" src={"../../../Assets/visuels/images/home/customer/" + item.Logo + ".webp"} alt={"Logo " + item.Client} />
                        <div className="Secteur">
                            <img loading="lazy" src={item.Icon} alt="" />
                            <p>{item.Secteur}</p>
                        </div>
                    </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}

export default Client;
